import { ErrorTypes } from './constants'

export default class NetworkError {
  type: number
  code: number
  additional?: any
  message: string
  constructor(
    type = ErrorTypes.JSON,
    code: number,
    message: string,
    additional?: any
  ) {
    this.type = type
    this.code = code
    this.message = message
    this.additional = additional
  }
}
